import emailadsOptInStore from '../store/emailadsOptInStore';
import { mutatorAction } from 'satcheljs';

export const setEmailadsOptInBit = mutatorAction('SetEmailadsOptInBit', (optInBit: number) => {
    // Set the optInBit to trigger the store change
    emailadsOptInStore.emailAdsOptInBit = optInBit;
});
